import React, { useEffect, useState } from 'react';
import { Button, Card, CardContent, CircularProgress, Grid, Modal, Typography, Backdrop, Fade } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { devolverNombreDomicilio, formatDate, formatDNI, isNullOrEmpty } from 'utils/utils';
import { EMPTY_FILE } from 'constants/icons';
import { useDispatch, useSelector } from 'react-redux';
import { parentescosList } from 'app/features/Parentescos/parentescosSlice';
import { tipoDocumentoList } from 'app/features/TipoDocumento/tipoDocumentoSlice';
import { tipoDomicilioList } from 'app/features/TipoDomicilio/tipoDomicilioSlice';
import { nuevoAdjunto } from 'utils/adjuntosLogic';
import Swal from 'sweetalert2';
import { TIPOS_USUARIO } from 'constants/constants';

export const DatosMatricula = ({ datos, bloquearBtn, setBloquearBtn, setDatos, setValue, loaderBtnGuardar, setLoaderBtnGuardar, idEstado, datosMatricula, datosFirma , tpoTramite, estadoProf, setAlertaFueMostrada, alertaFueMostrada, setDatosMatricula, estadoMatricular }) => {

  const dispatch = useDispatch();
  const editarFotoSlice = useSelector(state => state.editarDatosProfesionalReducer);
  const [croppedImage, setCroppedImage] = useState(null);
  const [open, setOpen] = useState(false);
  const Parentescos = useSelector(parentescosList);
  const TipoDocumentos = useSelector(tipoDocumentoList);
  const TipoDomicilios = useSelector(tipoDomicilioList);
  const titulosRR = useSelector(state => state.titulosRRReducer.titulosRR);
  //const estadoMatricular = Number(localStorage.estadoMatricular)

  const tipoDocFam = TipoDocumentos.filter(t => t.tipoDocumento === datos.TipoDocumento)[0]?.descripcion.trim();
  const userType = Number(localStorage.userType);
  

  const tamanioFuente = 18;
  let idLegajo = localStorage.userType !== "1" ? localStorage.idLegajo : datos.LegProf;
  let legProfFormateado = idLegajo.slice(0, idLegajo.length - 1) + '/' + idLegajo.slice(idLegajo.length - 1);

  const handleContinue = () => {

    if (editarFotoSlice.deseaCambiarFoto) {
        let adjuntoDeFoto = datos.adjuntos.find(a => a.fileType === "FotoPerfil");
        if (adjuntoDeFoto) {
            adjuntoDeFoto.file = editarFotoSlice.fotoNueva;
        } else {
            adjuntoDeFoto = nuevoAdjunto("FotoPerfil", "image/jpeg", editarFotoSlice.fotoNueva);
            datos.adjuntos.push(adjuntoDeFoto);
        }
        let adjuntoDeFotoFull = datos.adjuntos.find(a => a.fileType === "FotoPerfilFull");
        if (adjuntoDeFotoFull) {
            adjuntoDeFotoFull.file = editarFotoSlice.fotoNuevaFullSize;
        } else {
            adjuntoDeFotoFull = nuevoAdjunto("FotoPerfilFull", "image/jpeg", editarFotoSlice.fotoNuevaFullSize);
            datos.adjuntos.push(adjuntoDeFotoFull);
        }

    }

    setValue("2")
  }

  const handleClose = () => {
    setOpen(false);
  }

  const fechaFormateada = (value) => {
    if (localStorage.userType !== "1") {
        let fechaNacimiento = datosMatricula?.nacimiento.split(" ")[0]
        // let [dia, mes, anio] = fechaNacimiento.split("/");
        // if( !mes.startsWith("0")) {
        //     mes = "0" + mes 
        // }
        // return `${dia}/${mes}/${anio}`;
        return datosMatricula?.nacimiento.split(" ")[0]
    } else {
        return datosMatricula?.nacimiento.split(" ")[0]
    }

  }

    const calcularEdad = (fecha) => {
        let hoy = new Date();
        let cumpleanos = new Date(fecha);
        let edad = hoy.getFullYear() - cumpleanos.getFullYear();
        let m = hoy.getMonth() - cumpleanos.getMonth();

        if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
            edad--;
        }
        return edad;
    }

    const convertirFecha = string => {
        if (string.search('/') === -1) {
            var info = string.split('-');

            if (info[1].length === 1)
                info[1] = "0" + info[1];
        
            if (info[2].length === 1)
                info[2] = "0" + info[2];
        
            return info[0] + '-' + info[1] + '-' + info[2];
        }
        string = string.slice(0, string.search(' '));
        var info = string.split('/');

        if (info[1].length === 1)
            info[1] = "0" + info[1];

        if (info[0].length === 1)
            info[0] = "0" + info[0];

        return info[2] + '-' + info[1] + '-' + info[0];
    }

    const cargarDatos = () => {

        if (datosMatricula.familiares?.length > 0) {
            datosMatricula.familiares.map((fam) => {
                let fechaNacimiento = fam.fechaNacimiento.split(" ")[0];
                let [dia, mes, anio] = fechaNacimiento.split("/");
                fam.fechaNacimiento = `${anio}-${mes}-${dia}`;
                fam.edad = calcularEdad(fam.fechaNacimiento);
            });
        }

        
        let familiaresArr = [];

        datosMatricula.familiares.map((fam, index) => {
            let parentescoFam = Parentescos.filter(p => p.codParentesco === fam.codParentesco)[0]?.descripcion.trim();
            let tipoDocFam = TipoDocumentos.filter(t => t.tipoDocumento === fam.tipoDocumento)[0]?.descripcion.trim();
            familiaresArr.push({
                nombreParentesco: parentescoFam === undefined ? null : parentescoFam,
                nombreTipoDocumento: tipoDocFam === undefined ? null : tipoDocFam,
                apellido: fam.apellido.trim(),
                cargo: fam.cargo,
                codParentesco: fam.codParentesco,
                edad: Number(calcularEdad(convertirFecha(fam.fechaNacimiento))),
                fechaNacimiento: convertirFecha(fam.fechaNacimiento),
                id: index,
                incapacitado: fam.incapacitado,
                nombre: fam.nombre.trim(),
                codNacionalidad: fam.codNacionalidad,
                ocupacion: fam.ocupacion.trim(),
                lugarNacimiento: fam.lugarNacimiento,
                numeroDocumento: fam.numeroDocumento,
                obraSocial: fam.obraSocial.trim(),
                sexo: fam.sexo,
                tipoDocumento: fam.tipoDocumento,
                tpoOsocial: fam.tpoOsocial,
                idFam: fam.idFam,
                estado: fam.estado === null || fam.estado === undefined ? 1 : fam.estado,
            })
        })

        const contadorDomiciliosCorrectos = countDomicilios();
        let domiciliosArray = [];
        if(contadorDomiciliosCorrectos < 5) {
            for (let index = 1; index < 6; index++) {
                const domicilio = datosMatricula.domicilios.filter((domicilio) => domicilio.tpoDomicilio === index);
                if(domicilio.length > 0){
                    domiciliosArray.push(...domicilio)
                } else {
                    domiciliosArray.push({ tipoDomicilio: devolverNombreDomicilio(index), localidad: '', calle: '', numero: '', piso: '', depto: '', delegacion: '', codPostal: '', partido: '', provincia: '', telefono: '', celular: '', caracteristica: '', tpoDomicilio: index, caracteristicaFijo: "", tpoCarga: 0, tpoCalle: 0, codLocalidad: ""})
                }
            }
        }

        setDatos({
            Nombre: datosMatricula.nombre.trim(),
            Apellido: datosMatricula.apellido.trim(),
            PerteneceOtroConsejo: datosMatricula.perteneceOtroConsejo === undefined ? null : datosMatricula.perteneceOtroConsejo,
            Nacimiento: datosMatricula.nacimiento,
            NroDocumento: datosMatricula.nroDocumento,
            ObraSocial: datosMatricula.obraSocial !== undefined && datosMatricula.obraSocial !== null ? (datosMatricula.obraSocial === "0" ? "NINGUNA" : datosMatricula.obraSocial) : '',
            sexo: datosMatricula.sexo ? datosMatricula.sexo : 0,
            EstadoCivil: datosMatricula.estadoCivil ? datosMatricula.estadoCivil : '',
            TpoOsocial: datosMatricula.tpoOsocial,
            TipoDocumento: datosMatricula.tipoDocumento,
            CuitCuil: datosMatricula.cuitCuil,
            Nacionalidad: datosMatricula.nacionalidad ? datosMatricula.nacionalidad : '',
            CodNacionalidad: datosMatricula.nacionalidad.trim() === 'ARGENTINO' ? 1 : 2,
            Email: "",
            LegProf: localStorage.idLegajo,
            titulos: datosMatricula.titulos,
            familiares: familiaresArr,
            domicilios: Array.isArray(datosMatricula.domicilios) ? (contadorDomiciliosCorrectos < 5 ? domiciliosArray : datosMatricula.domicilios) : datos.domicilios,
            Celular: localStorage.tpoTramite !== "3" ? (datosMatricula.celular ? datosMatricula.celular : '') : '',
            // Celular: datosMatricula.celular ? datosMatricula.celular : '',
            EmailRepetido: "",
            CodEnt: datosMatricula.CodEnt ? datosMatricula.CodEnt : null,
            TipoTramite: datosMatricula.CodEnt ? datosMatricula.CodEnt : null,
            adjuntos: [
                { fileType: 'DNI del Solicitante - Anverso', fileName: '', extension: '', file: '', size: 0, url: EMPTY_FILE, saved: true },
                { fileType: 'DNI del Solicitante - Reverso', fileName: '', extension: '', file: '', size: 0, url: EMPTY_FILE, saved: true },
            ],
            estadoMatricular: userType === TIPOS_USUARIO.SECRETARIO_TECNICO ? datos.estadoMatricular : (Number(localStorage.estadoMatricular)),
        });
    }

    const countDomicilios = () => {
        let contadorDomiciliosCorrectos = 0;

        datosMatricula.domicilios.forEach((domicilio) => {
            if(domicilio.tipoDomicilio.trim() === "Particular" || domicilio.tipoDomicilio.trim() === "Profesional" || domicilio.tipoDomicilio.trim() === "Constituido" || domicilio.tipoDomicilio.trim() === "Correspondencia" || domicilio.tipoDomicilio.trim() === "Real Caja" ){
                contadorDomiciliosCorrectos++;
            }
        });

        return contadorDomiciliosCorrectos;
    }

    useEffect(() => {
        //Si no tiene cargados los datos en el JsonDatos
        if(datosMatricula && datos.Apellido === "") {
            cargarDatos();
        }
    }, [datosMatricula])

  return (
    <Grid container key={crypto.randomUUID()}>
    <Card sx={{ boxShadow: 5, background: '#e4f0ec', width: '100%', borderColor: '#b8daba', borderRadius: '5px', border: '3px solid #b8daba', mb:2 }}>
        <CardContent>
            <Grid display="flex" justifyContent="center" flexDirection={{ xs: 'column', sm: 'row' }} alignItems="center">
                <Typography variant="h6" component="span" textAlign='center' fontSize={{ xs: 16, sm: 18 }}>
                    {localStorage.tpoTramite !== "3" ? 'Actual Estado Matricular' : 'Estado Matricular' } : 
                    <b>{datos.estadoMatricular === 1 ? "Activo" : (tpoTramite === 7 ? "Cancelado" : "Suspendido")}</b>
                </Typography>
                <Typography variant="h6" component="span" textAlign='center' ml={{ xs: 0, sm: 2 }} mt={{ xs: 1, sm: 0 }} fontSize={{ xs: 16, sm: 18 }}>
                    Desde: <b>{formatDate(estadoProf?.fecEstado)}</b>
                </Typography>
            </Grid>
        </CardContent>
    </Card>
    <Card sx={{ boxShadow: 5, background: '#e4f0ec', width: '100%', borderColor: '#b8daba', borderRadius: '5px', border: '3px solid #b8daba'}}>
        <CardContent>
            <Grid item xs={12} md={12} mt={2}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <Typography fontSize={{ xs: 15, sm: tamanioFuente }}>Nombre: <b>{datosMatricula?.nombre}</b></Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography fontSize={{ xs: 15, sm: tamanioFuente }}>Apellido: <b>{datosMatricula?.apellido}</b></Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography fontSize={{ xs: 15, sm: tamanioFuente }}>Fecha de Nacimiento: <b>{fechaFormateada()}</b></Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} md={12} mt={2}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <Typography fontSize={{ xs: 15, sm: tamanioFuente }}>Tipo de documento: <b>{tipoDocFam}</b></Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography fontSize={{ xs: 15, sm: tamanioFuente }}>Numero: <b>{datosMatricula !== null && datosMatricula?.nroDocumento}</b></Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography fontSize={{ xs: 15, sm: tamanioFuente }}>Legajo: <b>{legProfFormateado}</b></Typography>
                    </Grid>
                </Grid>
            </Grid>
            {
                titulosRR?.map((titulos, index) => (
                    <Grid item xs={12} md={12} mt={2} key={`${titulos.id}-${index}`}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Typography fontSize={{ xs: 15, sm: tamanioFuente }}>Titulo: <b>{titulos.descrip.trim()}</b></Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography fontSize={{ xs: 15, sm: tamanioFuente }}>Tomo: <b>{titulos.tomo}</b></Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography fontSize={{ xs: 15, sm: tamanioFuente }}>Folio: <b>{titulos.folio}</b></Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                ))
            }
            <Grid item xs={12} md={12} mt={3}>
                <Typography fontSize={{ xs: 15, sm: tamanioFuente }} mb={2}>Firma del profesional registrada en el Sistema de Matrículas</Typography>
                {
                    (datosFirma?.firma) ?
                    <img
                        src={`data:image/jpeg;base64,${datosFirma?.firma}`}
                        alt="Firma"
                        onClick={() => setOpen(true)}
                        style={{
                            width: '100%',
                            maxWidth: '200px',
                            border: '2px solid #000',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            cursor: 'pointer'
                        }}
                    />
                    :
                    <Typography fontSize={{ xs: 15, sm: tamanioFuente }}><b><i>No se ha encontrado firma</i></b></Typography>
                }
            </Grid>
        </CardContent>
    </Card>
        {
            (datosFirma?.firma) &&
            <Modal
                open={open}
                onClose={handleClose}
                closeAfterTransition
            >
                <Fade in={open} timeout={500}>
                    <img
                        src={`data:image/jpeg;base64,${datosFirma?.firma}`}
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '90vw',
                            maxWidth: '400px',
                            height: 'auto',
                            border: '2px solid #000',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                        }}
                    />
                </Fade>
            </Modal>
        }
        <Grid sx={{ mt: 3 }} container justifyContent="flex-end">
            <Button endIcon={<ArrowForwardIosIcon />} disabled={bloquearBtn} variant="contained" onClick={handleContinue} color="secondary" >
                {loaderBtnGuardar === true ? <CircularProgress /> : ''}Continuar
            </Button>
        </Grid>
    </Grid>
  )
}